import { IButton } from 'common/builder/buttons/buttonInterfaces'
import {
  ButtonConverterRulePayload,
  ConverterRule,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { createConverterRulesArray } from 'common/builder/components/chart/FlowChart/lib/utils/createConverterRulesArray'
import { FlowChartButton } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'

import { CommonButtonGenericConverterRule } from './converterRules/CommonButtonGenericConverterRule'
import { FallbackButtonGenericConverterRule } from './converterRules/FallbackButtonGenericConverterRule'
import { NotificationRequestButtonGenericConverterRule } from './converterRules/NotificationRequestButtonGenericConverterRule'
import { SmartLinkButtonCommonConverterRule } from './converterRules/SmartLinkButtonCommonConverterRule'

export const GenericButtonConverterRules: Array<
  ConverterRule<IButton, FlowChartButton, ButtonConverterRulePayload>
> = createConverterRulesArray<IButton, FlowChartButton>(
  [
    SmartLinkButtonCommonConverterRule,
    NotificationRequestButtonGenericConverterRule,
    CommonButtonGenericConverterRule,
  ],
  FallbackButtonGenericConverterRule,
)
